
export default {
  name: 'DashboardCoreFooter',
  components: {
    PrivacyPolicyDialog: () => {
      if (process.client) {
        return import('@/components/dialog/PrivacyPolicyDialog.vue');
      }
    },
  },

  data: () => ({
    links: [
      {
        href: '#',
        text: 'Creative Tim',
      },
      {
        href: '#',
        text: 'About Us',
      },
      {
        href: '#',
        text: 'Blog',
      },
      {
        href: '#',
        text: 'Licenses',
      },
    ],
    privacyDialog: false,
  }),
  methods: {
    showPrivacyDialog() {
      this.privacyDialog = true;
    },
  },
};
